import React from 'react';

const closeIcon = (React.createElement("path", { d: "M19.4999 5.00006L5.5 19M5.49994 5L19.4999 18.9999", stroke: "#121212", strokeWidth: "1.5", strokeLinecap: "round" }));
const backIcon = (React.createElement("path", { d: "M20 12H4M4 12L10 6M4 12L10 18", stroke: "#121212", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }));

export { backIcon, closeIcon };
//# sourceMappingURL=icons.js.map
